import React from 'react';
import { HiCheckCircle } from 'react-icons/hi';

const highlights = [
  'Sales Growth & Marketing Strategy',
  'Data-Driven Decision Making',
  'Cyber Security & Data Science Expertise',
  'Career Advice & Professional Guidance',
];

const About = () => {
  return (
    <section id="about" className="section-padding bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Left - Visual */}
          <div className="relative">
            <div className="bg-gradient-to-br from-soft-pink to-accent/20 rounded-3xl p-8 md:p-12">
              <div className="bg-white rounded-2xl p-8 shadow-sm">
                <div className="space-y-6">
                  <div className="flex items-center gap-4">
                    <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
                      <span className="font-display text-2xl font-bold text-primary">
                        MN
                      </span>
                    </div>
                    <div>
                      <h3 className="font-semibold text-text-dark">
                        Marina Naznin
                      </h3>
                      <p className="text-sm text-text-light">
                        Sales & Marketing Manager
                      </p>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <div className="bg-soft-pink/50 rounded-xl p-4 text-center">
                      <p className="text-2xl font-bold text-primary-dark">1.5+</p>
                      <p className="text-xs text-text-light mt-1">
                        Years Experience
                      </p>
                    </div>
                    <div className="bg-soft-pink/50 rounded-xl p-4 text-center">
                      <p className="text-2xl font-bold text-primary-dark">
                          250+
                      </p>
                      <p className="text-xs text-text-light mt-1">
                        Happy Clients
                      </p>
                    </div>
                    <div className="bg-soft-pink/50 rounded-xl p-4 text-center">
                      <p className="text-2xl font-bold text-primary-dark">
                        UK
                      </p>
                      <p className="text-xs text-text-light mt-1">
                        Based
                      </p>
                    </div>
                    <div className="bg-soft-pink/50 rounded-xl p-4 text-center">
                      <p className="text-2xl font-bold text-primary-dark">
                        100%
                      </p>
                      <p className="text-xs text-text-light mt-1">
                        Dedication
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right - Content */}
          <div>
            <span className="text-primary font-medium text-sm tracking-wider uppercase">
              About Me
            </span>
            <h2 className="section-title text-left mt-2 mb-6">
              Blending Business Excellence{' '}
              <span className="text-primary">with Technical Expertise</span>
            </h2>
            <p className="text-text-light leading-relaxed mb-4">
              I am Marina Naznin, a Sales and Marketing Manager based in Scotland, UK, working with RBC Property Management Ltd. I bring a unique blend of business acumen and technical expertise to the corporate and digital landscape.
            </p>
            <p className="text-text-light leading-relaxed mb-4">
              I hold an M.Sc. in Cyber Security from the University of Wrexham, an M.Sc. in Computer Science & Engineering (Data Science), and a B.Sc. in Computer Science & Engineering from Daffodil International University, Bangladesh.
            </p>
            <p className="text-text-light leading-relaxed mb-8">
              I specialize in sales growth, marketing strategy, and client relationship management. Beyond my professional role, I'm passionate about career guidance, helping individuals align their skills and ambitions with real-world opportunities.
            </p>

            <div className="space-y-3">
              {highlights.map((item, index) => (
                <div key={index} className="flex items-center gap-3">
                  <HiCheckCircle className="text-primary text-xl flex-shrink-0" />
                  <span className="text-text-dark font-medium">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
